/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', function(){
    var variant_id = document.querySelector("[name='id']");
    var productJSON = JSON.parse(document.querySelectorAll('[data-product-json]')[0].innerHTML);
    var els = document.getElementsByClassName("sku");
      
    var listener = function listener(e){
      const variant_id = parseInt(e.target.value,10);
      for(const variant of productJSON.variants){
        if(variant.id === variant_id){
          for (var i = 0; i < els.length; i++) {
              els[i].innerHTML = variant.sku;
          }
        }
      }
    }
    variant_id.addEventListener('change', listener, false);
  }, false);
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
